import { flushSync } from 'react-dom'
import { Link, type LinkProps, useNavigate } from 'react-router-dom'

type TransitionDocument = Document & {
  startViewTransition?: (update: () => void) => { ready: Promise<void>; finished: Promise<void> }
}

let transitionId = 0

/** Keep real link behaviour, with a short crossfade for ordinary in-page navigation. */
export default function PortfolioPageLink({ to, onClick, children, ...props }: LinkProps) {
  const navigate = useNavigate()

  return <Link {...props} to={to} onClick={event => {
    onClick?.(event)
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || (props.target && props.target !== '_self')) return
    event.preventDefault()
    const update = () => flushSync(() => navigate(to, { replace: props.replace, state: props.state }))
    const doc = document as TransitionDocument
    if (!doc.startViewTransition || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      update()
      return
    }
    const id = ++transitionId
    document.documentElement.dataset.portfolioTransition = ''
    const transition = doc.startViewTransition(update)
    // A resized/hidden document can skip the visual transition; navigation still completes.
    void transition.ready.catch(() => {})
    void transition.finished.catch(() => {}).then(() => {
      if (id === transitionId) delete document.documentElement.dataset.portfolioTransition
    })
  }}>{children}</Link>
}
